import './App.css';
import { contentLoaderClosure } from './features/content/contentLoader';
import { contentStore } from '@lib/store/Contentstore';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { layoutLoaderClosure } from './features/ui/layoutLoader';
import { Provider } from 'jotai';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { signOutRedirectClosure } from './features/iam/signOutRedirect';
import { StrictMode } from 'react';
import ContentRoute from './routes/ContentRoute';
import ErrorPageManager from './routes/ErrorPageManager';
import Layout from './features/ui/Layout';
import OneTrust from './features/tagManagement/OneTrust';
import RoutePendingLayout from './features/ui/RoutePendingLayout';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/',
    id: 'root',
    loader: layoutLoaderClosure(queryClient),
    element: <Layout />,
    hydrateFallbackElement: <RoutePendingLayout />,
    errorElement: <ErrorPageManager />,
    children: [
      {
        id: 'logga-ut',
        path: 'logga-ut',
        loader: signOutRedirectClosure(),
        element: <>Du loggas ut</>,
      },
      { index: true, element: <ContentRoute />, loader: contentLoaderClosure(queryClient) },
      { path: '*', element: <ContentRoute />, loader: contentLoaderClosure(queryClient) },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={contentStore}>
      <QueryClientProvider client={queryClient}>
        <OneTrust />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
);
